(() => {
  'use strict';

  const PDF_ICON_URL =
    'https://cdn.shopify.com/s/files/1/0479/3617/6290/files/pdf_2.png?v=1730297080';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  function getFormat(link) {
    try {
      const pathname = new URL(
        link.getAttribute('href'),
        document.baseURI
      ).pathname;

      let filename = pathname.split('/').pop() || '';

      try {
        filename = decodeURIComponent(filename);
      } catch (_) {}

      const match = filename.match(/\.([a-z0-9]{1,10})$/i);

      return match ? match[1].toUpperCase() : '';
    } catch (_) {
      return '';
    }
  }

  function describeDocument(link, originalText, format) {
    const titleAttribute = link.getAttribute('title') || '';

    let filename = '';

    try {
      filename = new URL(
        link.getAttribute('href'),
        document.baseURI
      ).pathname.split('/').pop() || '';

      try {
        filename = decodeURIComponent(filename);
      } catch (_) {}
    } catch (_) {}

    const text = normalize(
      `${originalText} ${titleAttribute} ${filename}`
    ).replace(/[_-]+/g, ' ');

    const customTitle = link.getAttribute('data-document-title');
    const customDescription = link.getAttribute(
      'data-document-description'
    );
    const customButton = link.getAttribute('data-document-button');

    const cleanTitle = originalText
      .replace(/^\s*descargar\s+/i, '')
      .replace(/\s+PDF\s*$/i, '')
      .trim();

    let title = cleanTitle || 'Documento';
    let description = 'Documentación del producto.';
    let button = format
      ? `Descargar ${format}`
      : 'Abrir documento';

    let photometric = false;

    /* Archivos fotométricos IES y LDT */
    if (format === 'IES' || format === 'LDT') {
      title = `Archivo fotométrico ${format}`;

      description =
        'Datos para realizar cálculos de iluminación en DIALux y otros programas compatibles.';

      button = `Descargar ${format}`;
      photometric = true;
    }

    /* Informe fotométrico PDF u otros formatos */
    else if (
      text.includes('fotometr') ||
      /\b(ies|ldt)\b/.test(text)
    ) {
      if (format === 'PDF') {
        title = 'Informe fotométrico';

        description =
          'Curvas y datos de distribución de la luz.';

        button = 'Descargar informe';
      } else {
        title = 'Archivo fotométrico';

        description =
          'Datos para realizar cálculos de iluminación.';

        button = format
          ? `Descargar fotometría (${format})`
          : 'Abrir fotometría';

        photometric = true;
      }
    }

    /* Declaración UE de conformidad */
    else if (
      text.includes('declaracion') ||
      text.includes('declaration') ||
      text.includes('conformidad') ||
      text.includes('conformity') ||
      (
        /\b(ce|ue)\b/.test(text) &&
        /certific|certificate/.test(text)
      )
    ) {
      title = 'Declaración UE de conformidad';

      description =
        'Declaración del fabricante sobre la conformidad del producto con las directivas europeas indicadas.';

      button = 'Descargar declaración';
    }

    /* Ficha técnica del driver */
    else if (/\b(driver|drivers)\b/.test(text)) {
      const brands = [
        ['inventronics', 'Inventronics'],
        ['lifud', 'Lifud'],
        ['philips', 'Philips'],
        ['mean well', 'Mean Well'],
        ['meanwell', 'Mean Well'],
        ['tridonic', 'Tridonic'],
        ['osram', 'OSRAM']
      ];

      const brand = brands.find(([key]) => text.includes(key));

      title =
        'Ficha técnica del driver' +
        (brand ? ` ${brand[1]}` : '');

      description =
        'Características eléctricas y especificaciones del driver.';

      button = 'Descargar ficha del driver';
    }

    /* Manual de instalación */
    else if (
      text.includes('manual') ||
      text.includes('instalacion') ||
      text.includes('installation')
    ) {
      title = 'Manual de instalación';

      description =
        'Instrucciones de montaje y conexión del producto.';

      button = 'Descargar manual';
    }

    /* Instrucciones de uso */
    else if (text.includes('instruccion')) {
      title = 'Instrucciones de uso';

      description =
        'Indicaciones para el uso y funcionamiento del producto.';

      button = 'Descargar instrucciones';
    }

    /* Ficha técnica general */
    else if (
      text.includes('ficha') ||
      text.includes('datasheet') ||
      text.includes('data sheet')
    ) {
      title = 'Ficha técnica del producto';

      description =
        'Características y especificaciones del producto.';

      button = 'Descargar ficha';
    }

    /* Otros certificados */
    else if (text.includes('certific')) {
      title = cleanTitle || 'Certificado';

      description =
        'Documentación de certificación del producto.';

      button = 'Descargar certificado';
    }

    return {
      title: customTitle || title,
      description: customDescription || description,
      button: customButton || button,
      photometric
    };
  }

  function addSpan(parent, className, text) {
    const span = document.createElement('span');

    span.className = className;

    if (text) {
      span.textContent = text;
    }

    parent.appendChild(span);

    return span;
  }

  function createFileIcon(photometric, format) {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');

    svg.setAttribute('viewBox', '0 0 48 56');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('width', '40');
    svg.setAttribute('height', '48');

    svg.style.width = '28px';
    svg.style.height = '32px';
    svg.style.display = 'block';

    const paths = photometric
      ? [
          'M24 9v29 M10 38h28',
          'M24 17c-5 0-13 7-13 13 0 5 5 8 13 8s13-3 13-8c0-6-8-13-13-13Z',
          'M24 17c-3 0-7 7-7 13 0 5 3 8 7 8s7-3 7-8c0-6-4-13-7-13Z',
          'M8 20l32 14 M8 34l32-14'
        ]
      : [
          'M12 4h17l9 9v28H12V4Z',
          'M29 4v9h9 M18 22h14 M18 28h14 M18 34h9'
        ];

    paths.forEach(d => {
      const path = document.createElementNS(ns, 'path');

      path.setAttribute('d', d);
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.6');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');

      svg.appendChild(path);
    });

    if (format) {
      const text = document.createElementNS(ns, 'text');

      text.setAttribute('x', '24');
      text.setAttribute('y', '52');
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('fill', 'currentColor');
      text.setAttribute('font-family', 'inherit');
      text.setAttribute(
        'font-size',
        format.length > 4 ? '7' : '9'
      );
      text.setAttribute('font-weight', '600');

      text.textContent = format;

      svg.appendChild(text);
    }

    return svg;
  }

  function createDownloadArrow() {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');

    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');

    [
      'M12 4v10',
      'M8.5 10.5L12 14l3.5-3.5',
      'M5 19h14'
    ].forEach(d => {
      const path = document.createElementNS(ns, 'path');

      path.setAttribute('d', d);
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.9');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');

      svg.appendChild(path);
    });

    return svg;
  }

  function initDownloads(scope = document) {
    scope.querySelectorAll('#descargas a[href]').forEach(link => {
      if (link.dataset.downloadCardReady === 'true') {
        return;
      }

      const originalText = (
        link.dataset.documentOriginalText ||
        link.textContent ||
        ''
      )
        .replace(/\s+/g, ' ')
        .trim();

      if (!originalText) {
        return;
      }

      const format = getFormat(link);

      const info = describeDocument(
        link,
        originalText,
        format
      );

      link.dataset.documentOriginalText = originalText;
      link.dataset.fileType =
        format.toLowerCase() || 'document';

      link.classList.add('pdf-download-btn');

      link.classList.toggle(
        'pdf-download-btn--photometric',
        info.photometric
      );

      link.replaceChildren();

      /* Icono del documento */
      const media = addSpan(
        link,
        'pdf-download-btn__media'
      );

      media.setAttribute('aria-hidden', 'true');

      if (format === 'PDF') {
        const img = document.createElement('img');

        img.src = PDF_ICON_URL;
        img.alt = '';

        media.appendChild(img);
      } else {
        media.appendChild(
          createFileIcon(info.photometric, format)
        );
      }

      /* Textos del documento */
      const content = addSpan(
        link,
        'pdf-download-btn__content'
      );

      addSpan(
        content,
        'pdf-download-btn__eyebrow',
        info.title
      );

      addSpan(
        content,
        'pdf-download-btn__label',
        info.button
      );

      addSpan(
        content,
        'pdf-download-btn__subtext',
        info.description
      );

      /* Flecha de descarga */
      const arrow = addSpan(
        link,
        'pdf-download-btn__arrow'
      );

      arrow.setAttribute('aria-hidden', 'true');
      arrow.appendChild(createDownloadArrow());

      link.dataset.downloadCardReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initDownloads()
    );
  } else {
    initDownloads();
  }

  document.addEventListener(
    'shopify:section:load',
    () => initDownloads()
  );
})();